import Context from "./types/types";

const context: Context = {
	instance: null,
};

const state: any = {
	id: "login",
	initial: "waiting",
	context,
	states: {
		waiting: {
			on: {
				LOGIN_CLICKED: {
					target: "runLoginMethod",
				},
				AUTHENTICATION_SUCCESS: {
					target: "finished",
					actions: "setLocalStorage",
				},
			},
		},
		runLoginMethod: {
			always: [
				{
					target: "afterAuthentication",
					actions: "openPopup",
				},
				{
					target: "afterAuthentication",
					actions: "redirectToLoginPage",
				},
			],
		},

		afterAuthentication: {
			on: {
				AUTHENTICATION_SUCCESS: {
					target: "finished",
					actions: "setLocalStorage",
				},
				AUTHENTICATION_ERROR: {
					target: "finished",
				},
			},
		},
		finished: {
			target: "waiting",
			actions: ["redirectToManager"],
		},
	},
};

const config = {
	state,
};

export default config;
